var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeautyNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1001",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.964 10",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17954",
    transform: "translate(-1064.5 -189)",
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 9.976,
    fill: "none",
    stroke: "#4c43e2",
    "data-name": "Line 537",
    transform: "translate(1064.5 189.5)",
    className: "colorStroke707070 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 9.976,
    fill: "none",
    stroke: "#4c43e2",
    "data-name": "Line 538",
    transform: "translate(1064.5 198.5)",
    className: "colorStroke707070 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 9.976,
    fill: "none",
    stroke: "#4c43e2",
    "data-name": "Line 539",
    transform: "translate(1069.488 195.5)",
    className: "colorStroke707070 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 9.976,
    fill: "none",
    stroke: "#4c43e2",
    "data-name": "Line 540",
    transform: "translate(1069.488 192.5)",
    className: "colorStroke707070 svgStroke"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeautyNew);
export default __webpack_public_path__ + "static/media/beautyNew.529e7752f38cf2a3288304c778a06001.svg";
export { ForwardRef as ReactComponent };